export function parsePlacementText(text: string): Record<string, number> | null {
  const signMap: Record<string, number> = {
    aries: 0, ari: 0, taurus: 1, tau: 1, gemini: 2, gem: 2, cancer: 3, can: 3, cnc: 3,
    leo: 4, virgo: 5, vir: 5, libra: 6, lib: 6, scorpio: 7, sco: 7, scp: 7,
    sagittarius: 8, sag: 8, capricorn: 9, cap: 9, aquarius: 10, aqu: 10, aqr: 10,
    pisces: 11, pis: 11, psc: 11,
  };
  const planetMap: Record<string, string> = {
    sun: 'Sun', moon: 'Moon', mercury: 'Mercury', merc: 'Mercury',
    venus: 'Venus', mars: 'Mars', jupiter: 'Jupiter', jup: 'Jupiter',
    saturn: 'Saturn', sat: 'Saturn', uranus: 'Uranus', ura: 'Uranus', urn: 'Uranus',
    neptune: 'Neptune', nep: 'Neptune', npt: 'Neptune',
    pluto: 'Pluto', plu: 'Pluto', plt: 'Pluto',
    chiron: 'Chiron', chi: 'Chiron',
    node: 'Node', 'true node': 'Node', 'north node': 'Node',
    ascendant: 'AC', asc: 'AC', ac: 'AC',
    midheaven: 'MC', mc: 'MC',
  };
  const positions: Record<string, number> = {};
  const lines = text.split(/\n|;/);
  const planetPattern = /(sun|moon|mercury|merc|venus|mars|jupiter|jup|saturn|sat|uranus|ura|urn|neptune|nep|npt|pluto|plu|plt|chiron|chi|north node|true node|node|ascendant|asc|ac|midheaven|mc)[\s:]+(\d+)\s+([a-z]+)\s*(\d+)?/;
  for (const line of lines) {
    const cleaned = line.toLowerCase().replace(/[°'"′″]/g, ' ').replace(/\s+/g, ' ').trim();
    const match = cleaned.match(planetPattern);
    if (match) {
      const planet = planetMap[match[1]];
      const deg = parseInt(match[2]);
      const signName = match[3].slice(0, 3);
      const min = match[4] ? parseInt(match[4]) : 0;
      const signIdx = signMap[signName];
      if (planet && signIdx !== undefined) {
        positions[planet] = signIdx * 30 + deg + min / 60;
      }
    }
  }
  return Object.keys(positions).length > 0 ? positions : null;
}